export default "__VITE_ASSET__BTLtVBEa__"